module.exports = __webpack_public_path__ + "static/media/child.3ecefaef.png";